import useAuth from "@/hooks/useAuth";
import { getUserPreferenceByKey } from "@/pages/settings/api";
import { useQuery } from "@tanstack/react-query";

type SquawkConnectionType = "web_rtc" | "web_sockets" | "shoutcast";

export const useGetSquawkConnectionType = () => {
  const { authenticated } = useAuth();

  return useQuery({
    queryKey: ["squawkConnectionTypePref"],
    queryFn: () =>
      getUserPreferenceByKey(
        "squawk_connection_type"
      ) as Promise<SquawkConnectionType>,
    enabled: authenticated,
  });
};
